import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-white.png'


const _withScopeId = n => (_pushScopeId("data-v-dcdd72c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-footer" }
const _hoisted_2 = { class: "site-middle-auto footer-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-left" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = { class: "footer-right" }
const _hoisted_5 = { class: "footer-top" }
const _hoisted_6 = { class: "f-4" }
const _hoisted_7 = { style: {"color":"rgba(255, 255, 255, 0.7)"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, " 企业客服电话：0551-62220000 "),
  /*#__PURE__*/_createElementVNode("span", null, " 版权所有：安徽省招标集团股份有限公司 ")
], -1))
const _hoisted_9 = { class: "f-b" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "版权所有：安徽省招标集团股份有限公司", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn",
    target: "_blank",
    class: "f-3"
  }, " 皖ICP备05004986号-3 ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "运营支持：安徽智云上数字科技有限公司 ", -1))

import { LinkNode } from "./link-node";
import { useUserStore } from "@/store/modules/user/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'app-footer',
  setup(__props) {

const userStore = useUserStore();

const changeTab = (activeKey: string) => {
  userStore.setMenuKey(activeKey);
};

return (_ctx: any,_cache: any) => {
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_space, { size: 56 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "f-1",
                    onClick: _cache[0] || (_cache[0] = () => changeTab('/'))
                  }, [
                    _createTextVNode(" 网站首页 "),
                    _createVNode(_unref(LinkNode), { path: "/" })
                  ]),
                  _createElementVNode("div", {
                    class: "f-1",
                    onClick: _cache[1] || (_cache[1] = () => changeTab('/site-search?pType=1'))
                  }, [
                    _createTextVNode(" 招标采购 "),
                    _createVNode(_unref(LinkNode), { path: "/site-search?pType=1" })
                  ]),
                  _createElementVNode("div", {
                    class: "f-1",
                    onClick: _cache[2] || (_cache[2] = () => changeTab('/site-search?pType=2'))
                  }, [
                    _createTextVNode(" 政府采购 "),
                    _createVNode(_unref(LinkNode), { path: "/site-search?pType=2" })
                  ]),
                  _createElementVNode("div", {
                    class: "f-1",
                    onClick: _cache[3] || (_cache[3] = () => changeTab('/site-search?pType=3'))
                  }, [
                    _createTextVNode(" 寻源快采 "),
                    _createVNode(_unref(LinkNode), { path: "/site-search?pType=3" })
                  ]),
                  _createElementVNode("div", {
                    class: "f-1",
                    onClick: _cache[4] || (_cache[4] = () => changeTab('/site-info'))
                  }, [
                    _createTextVNode(" 行业资讯 "),
                    _createVNode(_unref(LinkNode), { path: "/site-info" })
                  ])
                ]),
                _: 1
              })
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, "CopyRight© " + _toDisplayString(new Date().getFullYear()), 1),
              _hoisted_10,
              _hoisted_11,
              _hoisted_12
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})